import { render, staticRenderFns } from "./Door.vue?vue&type=template&id=c6dbca10&scoped=true"
import script from "./Door.vue?vue&type=script&lang=ts"
export * from "./Door.vue?vue&type=script&lang=ts"
import style0 from "./Door.vue?vue&type=style&index=0&id=c6dbca10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6dbca10",
  null
  
)

export default component.exports